module.exports = __webpack_public_path__ + "join_table.c0cf9a1.png";